import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { connect as connectStaticText } from 'components/StaticText/connect'
import { getBoundActions } from 'actions'
import FormsyForm from 'formsy-react'
import { EmailInput, Checkbox } from 'components/FormInput.v2'
import { FORM_INPUT_NAME_EMAIL_OPT_IN } from 'services/form'
import Button, { TYPES } from 'components/Button'

class ModalLiveAccessEmailCapture extends React.Component {
  constructor (props) {
    super(props)
    this.validEmail = this.validEmail.bind(this)
    this.inValidEmail = this.inValidEmail.bind(this)
    this.state = {
      siteUrl: '',
      isValidEmail: false,
    }
  }

  onValidSubmit = (model) => {
    const { props } = this
    const { doEmailSignup, id, speakerName } = props
    const { email } = model
    const source = `Gaia+ - ${id}`
    doEmailSignup(email, source, {}, '', true, false, speakerName)
  }

  onSelectOptInCheckbox = (name, checked) => {
    const { setEmailSignupOptin } = this.props

    setEmailSignupOptin(checked)
  }

  validEmail () {
    this.setState({ isValidEmail: true })
  }

  inValidEmail () {
    this.setState({ isValidEmail: false })
  }

  renderForm = (success) => {
    const { props, state } = this
    const { staticText, userEmail, emailSignup } = props
    const emailOptIn = emailSignup.get('optIn', false)
    const canSubmit = state.isValidEmail && !!emailSignup.get('optIn')
    return (
      <FormsyForm
        onValidSubmit={this.onValidSubmit}
        onValid={this.validEmail}
        onInvalid={this.inValidEmail}
      >
        <div className={success ? 'modal-live-access__email--invisible' : ''}>
          <EmailInput
            label={staticText.getIn(['data', 'email'])}
            name="email"
            value={userEmail}
            validations="isEmail"
            required
          />
        </div>
        <Checkbox
          onChange={this.onSelectOptInCheckbox}
          name={FORM_INPUT_NAME_EMAIL_OPT_IN}
          label={staticText.getIn(['data', 'optIn'])}
          value={emailOptIn}
          className="modal-live-access__optin"
          required
        />
        {success
          ? (
            <div className="modal-live-access__thankyou">
              {staticText.getIn(['data', 'thankYou'])}
            </div>
          )
          : (
            <Button
              type={TYPES.PRIMARY}
              submit
              className="modal-live-access__email-submit"
              disabled={!canSubmit}
              stacked
            >
              {staticText.getIn(['data', 'signUp'])}
            </Button>
          )}
      </FormsyForm>
    )
  }

  render () {
    const { props } = this
    const { staticText, emailSignup } = props
    return (
      <div className="modal-live-access">
        <div className="modal-live-access__description">
          {staticText.getIn(['data', 'signUpLong'])}
        </div>
        {this.renderForm(emailSignup.get('success'))}
      </div>
    )
  }
}

export default compose(
  connectStaticText({ storeKey: 'modalLiveAccessEmailCapture' }),
  connectRedux(
    (state) => ({
      share: state.share,
      emailSignup: state.emailSignup,
      userEmail: state.user.getIn(['data', 'mail']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        renderModal: actions.dialog.renderModal,
        doEmailSignup: actions.emailSignup.doEmailSignupBrooklyn,
        clearShare: actions.share.clearShare,
        setEmailSignupOptin: actions.emailSignup.setEmailSignupOptin,
      }
    },
  ),
)(ModalLiveAccessEmailCapture)
